/**
 * contentApi.js — public (unauthenticated) website content.
 * Products and testimonials are managed from the admin portal.
 */

const BASE_URL = process.env.REACT_APP_API_URL || 'https://quantum-stack.com';

async function getJson(path) {
  const res = await fetch(`${BASE_URL}${path}`, { headers: { Accept: 'application/json' } });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const body = await res.json();
  return body && typeof body === 'object' && 'success' in body ? body.data : body;
}

export const fetchProducts = () => getJson('/api/products');
export const fetchTestimonials = () => getJson('/api/testimonials');

/** Only allow http(s) links to be rendered as hrefs / media sources. */
export function safeUrl(url) {
  return typeof url === 'string' && /^https?:\/\//i.test(url.trim()) ? url.trim() : null;
}

export const STATUS_LABELS = {
  PLANNED: 'Planned',
  IN_DEVELOPMENT: 'In development',
  BETA: 'Beta',
  LIVE: 'Live',
};
